import { ExportedFileList } from 'src/Containers/Exports/ExportPage/ExportedFileList';
import { FullScreenFormWrapper } from 'src/Containers/FullScreenFormWrapper';
import useFetchExport from 'src/Hooks/Queries/useFetchExport';
import { AssetStorageItemDto } from 'src/Services/API/generated';

import { Props } from './ExportFilesPage.types';

const ExportFilesPage = ({ token }: Props) => {
  const { data, isLoading } = useFetchExport(token);

  return (
    <FullScreenFormWrapper maxWidth={1200}>
      <ExportedFileList
        files={data?.entities as unknown as AssetStorageItemDto[]}
        loading={isLoading}
      />
    </FullScreenFormWrapper>
  );
};

export default ExportFilesPage;
